"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleType = exports.AttributeType = exports.PersonaLinkRecordOrientation = void 0;
var PersonaLinkRecordOrientation;
(function (PersonaLinkRecordOrientation) {
    PersonaLinkRecordOrientation["INCLUSIONARY"] = "INCLUSIONARY";
    PersonaLinkRecordOrientation["EXCLUSIONARY"] = "EXCLUSIONARY";
})(PersonaLinkRecordOrientation || (exports.PersonaLinkRecordOrientation = PersonaLinkRecordOrientation = {}));
var AttributeType;
(function (AttributeType) {
    AttributeType["HOME_STATE"] = "HOME_STATE";
    AttributeType["HOME_COUNTRY"] = "HOME_COUNTRY";
    AttributeType["WORK_STATE"] = "WORK_STATE";
    AttributeType["WORK_COUNTRY"] = "WORK_COUNTRY";
    AttributeType["GROUP_NAME"] = "GROUP_NAME";
    AttributeType["JOB_TITLE"] = "JOB_TITLE";
    AttributeType["EMPLOYMENT_STATUS"] = "EMPLOYMENT_STATUS";
})(AttributeType || (exports.AttributeType = AttributeType = {}));
var RuleType;
(function (RuleType) {
    RuleType["IS"] = "IS";
    RuleType["IS_NOT"] = "IS_NOT";
    RuleType["IS_ONE_OF"] = "IS_ONE_OF";
    RuleType["IS_NOT_ONE_OF"] = "IS_NOT_ONE_OF";
    RuleType["CONTAINS"] = "CONTAINS";
    RuleType["DOES_NOT_CONTAIN"] = "DOES_NOT_CONTAIN";
})(RuleType || (exports.RuleType = RuleType = {}));
